import { format } from 'date-fns-tz'
import { mapGetters } from 'vuex'
import { eventsConstants } from './eventsList'

const mixpanelEvent = {
  computed: {
    eventsConstants() {
      return eventsConstants
    },
  },
  methods: {
    sendMixpanelEvent(event, payload = {}) {
      if (this.$store.state.auth.isAuthenticated) {
        this.$store.dispatch('content/sendMixpanelEvent', {
          event_name: event,
          properties: {
            ...payload,
          },
        })
      }
    },
  },
}

export const localTimezone = {
  computed: {
    localTimeZone() {
      return Intl.DateTimeFormat()
        .resolvedOptions()
        .timeZone.replace(/_/g, ' ')
    },
  },
}

export const bootcampCommons = {
  computed: {
    learningAreaName() {
      const {
        bootcamp: { learning_areas },
      } = this
      return learning_areas && learning_areas[0] && learning_areas[0].name
        ? learning_areas[0].name
        : 'IT Essentials'
    },
    contentInstructors() {
      const content = this.bootcamp || this.parent
      if (content.instructors.length === 2) {
        return `${content.instructors[0].name} and ${content.instructors[1].name}`
      }
      const threeFirst = content.instructors
        .slice(0, 3)
        .map(item => {
          return item.name ? item.name : 'INE Instructor'
        })
        .join(', ')
      return `${threeFirst}${
        content.instructors.length > 3
          ? ` and ${content.instructors.length - 3} more`
          : ''
      }`
    },
    bootcampDate() {
      const {
        bootcamp: { start_datetime: start, end_datetime: end },
      } = this
      const startDate = new Date(start)
      const endDate = new Date(end)
      const sameMonth = format(endDate, 'MMMM') === format(startDate, 'MMMM')
      const toEndDate = sameMonth
        ? format(endDate, 'do')
        : format(endDate, 'MMMM do')
      return `
      ${format(startDate, 'MMMM do')} - ${toEndDate}`
    },
    userRegistered() {
      const { bootcamp } = this
      return bootcamp.user_status && bootcamp.user_status.registered
    },
    limitedInstructors() {
      return this.bootcamp.instructors && this.bootcamp.instructors.length
        ? this.bootcamp.instructors.slice(0, 3)
        : []
    },
  },
  methods: {
    getInstructorImg(instructor) {
      return instructor && instructor.profile_img_url
        ? instructor.profile_img_url
        : require('@/assets/images/instructor_fallback.png')
    },
    getInstructorName(instructor) {
      return instructor && instructor.name ? instructor.name : 'INE Instructor'
    },
  },
}

export const videoBookmarks = {
  computed: {
    ...mapGetters({
      courseBookmarks: 'content/courseBookmarks',
    }),
    videoBookmarks() {
      return this.courseBookmarks.reduce((acc, bookmark) => {
        if (bookmark.video === this.content.id)
          acc.push({
            begin: bookmark.time,
            cueType: 'bookmark',
            text: bookmark.notes,
          })
        return acc
      }, [])
    },
  },
  methods: {
    _addBookmarksClues() {
      // jwPlayer instance
      if (this.instance) this.instance.addCues(this.videoBookmarks)
    },
  },
  watch: {
    courseBookmarks() {
      this._addBookmarksClues()
    },
  },
}

export const windowResize = {
  provide() {
    return {
      getBreakpoint: () => this.breakpoint,
    }
  },
  data() {
    return {
      breakpoint: null,
    }
  },
  methods: {
    setBreakpoint(windowWidth) {
      if (windowWidth) {
        if (windowWidth >= 1800) this.breakpoint = 'lg-desktop'
        else if (windowWidth >= 1300) this.breakpoint = 'desktop'
        else if (windowWidth >= 1024) this.breakpoint = 'tablet'
        else this.breakpoint = 'mobile'
      }
    },
  },
  mounted() {
    this.setBreakpoint(window.innerWidth)

    window.addEventListener('resize', () => {
      this.setBreakpoint(window.innerWidth)
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => null)
  },
}

export default mixpanelEvent
